import React from 'react';
import { SwitchButtonStyled } from './elements';

export default React.forwardRef<any, any>((props, ref) => <SwitchButtonStyled
		focusVisibleClassName=".Mui-focusVisible"
		disableRipple
		{...props}
		ref={ref}
	/>);
